module.exports = __webpack_public_path__ + "img/statistics.d53746b5.png";